import React from 'react';
import { ReactPlayer, Card, Alert, AppLocaleProvider } from 'sd-ui-components';
import { observer, inject } from 'mobx-react';
import 'url-search-params-polyfill';
import './EventVideo.less';
import { useOidc } from '@axa-fr/react-oidc';

const { FormattedMessage } = AppLocaleProvider;

// The wrapper for the video player has to be a react component.
// This is just a very simple div with a class so we can apply the style to the <video> element inside.
class VideoWrapper extends React.Component {
  render() {
    return <div className="video-wrapper"> {this.props.children}</div>;
  }
}
@inject('AuthStore')
@observer
class EventVideo extends React.Component {
  state = {
    playing: false,
    error: false
  };

  pause() {
    this.setState({ playing: false });
  }

  play() {
    this.setState({ playing: true });
  }

  constructVideoUrl(baseUrl) {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('accessToken', this.props.AuthStore.accessToken);
    return `${baseUrl}?${urlSearchParams.toString()}`;
  }

  onReady() {
    this.setState({ error: false });
    this.props.onReady &&
      this.props.onReady(
        () => this.pause(),
        () => this.play()
      );
  }

  onError() {
    const { logout, isAuthenticated } = useOidc();
    if (!this.props.AuthStore.isAuthenticated) {
      if (isAuthenticated) {
        logout('/');
        this.props.AuthStore.removeStorageForLogout();
        return;
      } else {
        this.props.AuthStore.logout();
        return;
      }
    }

    this.setState({ error: true });
  }

  render() {
    const videoUrl = this.constructVideoUrl(this.props.videoUrl);
    return (
      <div>
        {this.state.error && (
          <Alert
            className="safety-notifications"
            type={'error'}
            message={
              <FormattedMessage
                id="App.EventDetails.Errors.VideoUnavailable"
                defaultMessage="Video currently unavailable"
              />
            }
            showIcon
          />
        )}
        {this.props.loading && <Card loading={true} />}
        {this.props.videoUrl && !this.state.error && (
          <ReactPlayer
            ref={this.ref}
            wrapper={VideoWrapper}
            url={videoUrl}
            width="100%"
            height="100%"
            onPlay={() => this.play()}
            onPause={() => this.pause()}
            onReady={() => this.onReady()}
            onError={() => this.onError()}
            playing={this.state.playing}
            playsinline={true}
            controls={true}
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload'
                }
              }
            }}
          />
        )}
      </div>
    );
  }
}

export default EventVideo;



// WEBPACK FOOTER //
// ./src/containers/EventDetails/EventVideo.jsx